import { MyIcon } from '@/assets/icons/MyIcon';
interface Props {
  val: any;
  name?: string;
}

export default function Arrow({ val, name, ...other }: Props) {
  return <MyIcon {...val} name={'arrow'} size={20} className={`${val.className}`} style={{ opacity: name === 'disable' ? 0.3 : 1 }} />;
}
